const buildSectionStudents = (students, subgroupStudents = []) => {
  const mappedStudents = (students || []).map((student) => ({
    user_id: student.initId || student.id,
    apuid: student.apuid,
    first_name: student.firstName,
    last_name: student.lastName,
    email: student.email,
  }));
  /**
   * return all students for a full-class assignment, or when we don't want to
   * filter by subgroup
   */
  if ((subgroupStudents || []).length === 0) {
    return mappedStudents;
  }

  /**
   * Otherwise we have and want to filter by the subgroup array
   */
  return mappedStudents.filter(({ user_id }) =>
    subgroupStudents.includes(Number.parseInt(user_id, 10)),
  );
};

export default buildSectionStudents;
